import React, { useState } from 'react';
import Loading from '../components/Loading';
import { getVedicAstrology, isGeminiReady } from '../services/geminiService';
import { useLanguage } from '../context/LanguageContext';

export default function VedicAstrology() {
  const [form, setForm] = useState({ name: '', dob: '', timeOfBirth: '', placeOfBirth: '' });
  const [reading, setReading] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { language, t } = useLanguage();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.dob) {
      setError(t('fillNameDob'));
      return;
    }
    if (!isGeminiReady()) {
      setError(t('apiKeyError'));
      return;
    }
    setLoading(true);
    setError('');
    setReading('');
    try {
      const result = await getVedicAstrology(form.name, form.dob, form.timeOfBirth || 'Unknown', form.placeOfBirth || 'Unknown', language);
      setReading(result);
    } catch (err) {
      setError(err.message || 'Failed to generate Vedic reading.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="container">
        <div className="page-header">
          <h2>{t('vedicTitle')}</h2>
          <p>{t('vedicDesc')}</p>
        </div>

        <div className="card" style={{ maxWidth: '600px', margin: '0 auto 2rem' }}>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>{t('fullName')}</label>
              <input type="text" name="name" value={form.name} onChange={handleChange} placeholder={t('enterFullName')} required />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>{t('dateOfBirth')}</label>
                <input type="date" name="dob" value={form.dob} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>{t('timeOfBirth')}</label>
                <input type="time" name="timeOfBirth" value={form.timeOfBirth} onChange={handleChange} />
              </div>
            </div>
            <div className="form-group">
              <label>{t('placeOfBirth')}</label>
              <input type="text" name="placeOfBirth" value={form.placeOfBirth} onChange={handleChange} placeholder={t('cityCountry')} />
            </div>
            <button className="btn btn-gold" type="submit" disabled={loading} style={{ width: '100%' }}>
              {loading ? t('consultingJyotish') : t('getVedicReading')}
            </button>
          </form>
        </div>

        {loading && <Loading message={t('loadingVedic')} />}
        {error && <div className="error-message">{error}</div>}

        {reading && (
          <div className="result-container">
            <div className="result-card">
              <h3>{t('vedicResult', { name: form.name })}</h3>
              <div className="content">{reading}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
